<template>
    <v-container class="top-banner px-0">
        <v-layout>
            <div class="white--text text-uppercase hidden-xs-only">
                <strong>DONÁŠKA V GALERII HARFA ZDARMA</strong>
            </div>
            <v-spacer class="hidden-xs-only"></v-spacer>
            <div class="text-uppercase">
                <strong class="mr-2"><span class="primary--text">Telefonické objednávky</span></strong>
                <strong><a class="white--text" href="tel:+420602715668">+420 602 715 668</a></strong>
                <strong class="facebook">
                    <a href="https://www.facebook.com/FruitisimoBistroHarfa/" target="_blank">
                        <v-icon color="white" small>mdi-facebook</v-icon>
                    </a>
                </strong>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'TopBanner'
    }
</script>

<style lang="scss">
    .top-banner {
        border-bottom: 1px solid rgba(88, 88, 88, 1);
        font-size: 12px;
        strong {
            font-weight: 600;
        }
        a {
            text-decoration: none;
        }
        .facebook {
            margin-left: 5px;
            padding-left: 5px;
            border-left: 1px solid rgba(88, 88, 88, 1);
        }
    }
</style>
